import axios from 'axios'
import {
  getList,
  getExport,
  getImportTemplate,
  getDetail,
  getAdd,
  getEdit,
  getDelete,
  getBatchDelete,
  getEnable,
  getDisable,
  getBatchEnable,
  getBatchDisable,
  getCheckPass,
  getCheckRefuse,
  getBatchCheckPass
} from './request'

function getDivLevel1 (arr, id, type, level) {
  if (!arr) {
    return false
  }
  for (let i = 0; i < arr.length; i++) {
    let tree = arr[i]
    let flag = getDivLevel2(tree, id, type, level)
    if (flag) {
      return true
    }
  }
  return false
}
function getDivLevel2 (tree, id, type, level) {
  if (type) {
    if (type == tree.type && id == tree.id) {
      level.unshift({ id: Number(tree.id), type: tree.type, name: tree.name })
      return true
    }
  } else {
    if (tree.childs == null && id == tree.id) {
      level.unshift({ id: Number(tree.id), type: tree.type, name: tree.name })
      return true
    }
  }
  if (tree.childs) {
    let flag = getDivLevel1(tree.childs, id, type, level)
    if (flag) {
      level.unshift({ id: Number(tree.id), type: tree.type, name: tree.name })
      return true
    }
  }
  return false
}

export default {
  // -------------------------------------------------页面事件处理
  getPageHeight () {
    this.$nextTick(() => {
      if (this.$refs.query && this.$refs.query.$el) {
        this.pageHeight = window.innerHeight - this.$refs.query.$el.offsetHeight - 172 + 'px'
      }
    })
  },
  getTreeDef (treeList, value) {
    let treeDef = []
    treeList.forEach(tree => {
      if (tree.children == null) {
        if (tree.value == value) {
          treeDef.push(tree)
        }
      } else if (tree.children) {
        let defList = this.getTreeDef(tree.children, value)
        if (defList) {
          treeDef.push(...defList)
        }
      }
    })
    return treeDef
  },
  getDivLevel (id, type) {
    let tmpLevel = []
    if (id) {
      getDivLevel1(this.userTree, id, type, tmpLevel)
    }
    this.divLevel = tmpLevel
    return tmpLevel
  },
  onDivClick (tree) {
    let type = tree.type
    let id = tree.id
    // console.log('onDivClick', 'id', id)
    if (type === 6) { // 设备,跳转至子设备页面，查询条件设备
      this.$router.push({ name: 'userplatDevUsersub', query: { userDevId: id } })
    } else if (type === 5) { // 网关,跳转至设备列表，查询条件网关
      this.$router.push({ name: 'userplatDevUserdev', query: { userGwId: id } })
    } else if (type === 4) { // 点位,跳转至网关列表，查询条件点位
      this.$router.push({ name: 'userplatDevUsergw', query: { userPointId: id } })
    } else if (type === 3) { // 仓库，跳转至点位列表，查询条件仓库
      this.$router.push({ name: 'userplatDevUserpoint', query: { userStoreId: id } })
    } else if (type === 2) { // 工厂，跳转至仓库列表，查询条件工厂
      this.$router.push({ name: 'userplatProdUserstore', query: { userFactId: id } })
    }
  },
  putQuery (id, type) {
    this.formQuery.userDevId = ''
    this.formQuery.userGwId = ''
    this.formQuery.userPointId = ''
    this.formQuery.userStoreId = ''
    this.formQuery.userFactId = ''
    id = Number(id)
    if (type === 6) {
      this.formQuery.userDevId = id
    } else if (type === 5) {
      this.formQuery.userGwId = id
    } else if (type === 4) {
      this.formQuery.userPointId = id
    } else if (type === 3) {
      this.formQuery.userStoreId = id
    } else if (type === 2) {
      this.formQuery.userFactId = id
    }
  },
  getQuery () {
    let type = null
    let id = 0
    if (this.formQuery.userDevId) {
      id = this.formQuery.userDevId
      type = 6
    } else if (this.formQuery.userGwId) {
      id = this.formQuery.userGwId
      type = 5
    } else if (this.formQuery.userPointId) {
      id = this.formQuery.userPointId
      type = 4
    } else if (this.formQuery.userStoreId) {
      id = this.formQuery.userStoreId
      type = 3
    } else if (this.formQuery.userFactId) {
      id = this.formQuery.userFactId
      type = 2
    }
    return [id, type]
  },
  mountedTree () {
    let type = null
    let id = 0
    const query = this.$route.query
    if (query.userDevId) {
      id = query.userDevId
      type = 6
      this.formQuery.userDevId = id
    } else if (query.userGwId) {
      id = query.userGwId
      type = 5
      this.formQuery.userGwId = id
    } else if (query.userPointId) {
      id = query.userPointId
      type = 4
      this.formQuery.userPointId = id
    } else if (query.userStoreId) {
      id = query.userStoreId
      type = 3
      this.formQuery.userStoreId = id
    } else if (query.userFactId) {
      id = query.userFactId
      type = 2
      this.formQuery.userFactId = id
    }
    this.divTree = { id: id, type: type }
    this.userTreeDefExpa = [`${type}_${id}`]
  },
  routeTree (to) {
    if (this.menuName != to.name) { // 切走不处理
      return
    }
    let query = to.query
    if (Object.keys(query).length < 1) {
      return
    }
    let type = null
    let id = 0
    if (query.userDevId) {
      id = query.userDevId
      type = 6
      this.formQuery.userDevId = id
    } else if (query.userGwId) {
      id = query.userGwId
      type = 5
      this.formQuery.userGwId = id
    } else if (query.userPointId) {
      id = query.userPointId
      type = 4
      this.formQuery.userPointId = id
    } else if (query.userStoreId) {
      id = query.userStoreId
      type = 3
      this.formQuery.userStoreId = id
    } else if (query.userFactId) {
      id = query.userFactId
      type = 2
      this.formQuery.userFactId = id
    }
    this.httpQuery()
    this.userTreeDefExpa = [`${type}_${id}`]
    this.getDivLevel(id, type)
  },
  onCurrentChange (val) { // 当前页发生改变
    this.pageParam.pageNo = val
  },
  onSizeChange (val) { // 分页大小发生改变
    this.pageParam.pageNo = 1
    this.pageParam.pageSize = val
  },
  onQuery () { // 查询
    this.onPageQuery()
  },
  onPageQuery () {
    this.pageParam.pageNo = 1
    // this.pageParam.pageSize = 30
    this.httpQuery()
  },
  onRoutePush (name, query) { // 跳转
    this.$router.push({
      name,
      query
    })
  },
  onSelectionChange (items) {
    this.dataSelectList = []
    items.forEach((item, index) => {
      this.dataSelectList.push(item[this.idName])
    })
  },
  onResetForm (formName) { // 清空表单
    this.$refs[formName].resetFields()
    if (this.onAddTreeInit) {
      this.onAddTreeInit()
    }
  },
  onDetail (index, row) { // 详情
    this.httpDetail(row, 'dialogDetail')
  },
  onShowAdd () { // 显示新增
    this.dialogAdd = true
  },
  onSubmitAdd () { // 提交新增
    this.$refs.formAdd.validate((valid) => {
      if (valid) {
        this.httpAdd()
      } else {
        // console.log('error http!!')
        return false
      }
    })
  },
  onShowEdit (index, row) { // 显示编辑
    this.httpDetail(row, 'dialogModify')
  },
  onSubmitEdit () { // 提交编辑
    this.$refs.formEdit.validate((valid) => {
      if (valid) {
        this.$confirm('确认修改？').then(_ => {
          this.httpEdit()
        }).catch(_ => {})
      } else {
        // console.log('error http!!')
        return false
      }
    })
  },
  onResetEdit () { // 重置编辑
    // this.httpDetail(this.formEdit)
    this.formEdit = Object.assign({}, this.dataDetail)
    if (this.onEditTreeInit) {
      this.onEditTreeInit()
    }
  },
  onPageRemove (index, row) { // 删除
    // console.log(index, row)
    let tip = (this.removeTip ? this.removeTip(row) : null) || '确认删除？'
    this.$confirm(tip, {
      dangerouslyUseHTMLString: true
    }).then(_ => {
      this.httpDelete(row)
    }).catch(_ => {})
  },
  onBatchRemove () { // 批量删除
    this.onBatchAble('delete')
  },
  onBatchEnable () { // 批量启用
    this.onBatchAble('enable')
  },
  onBatchDisable () { // 批量启用
    this.onBatchAble('disable')
  },
  onBatchCheckPass () {
    this.onBatchAble('checkPass')
  },
  onBatchCheckRefuse () {
    this.onBatchAble('checkRefuse')
  },
  onBatchAble (t) { // 批量事件
    this.$confirm('确认要勾选的数据').then(() => {
      if (this.dataSelectList.length == 0) {
        this.$message.warning('请先勾选数据')
        return
      }
      switch (t) {
        case 'enable':
          this.httpBatchEnable(this.dataSelectList)
          break
        case 'delete':
          this.httpBatchDelete(this.dataSelectList)
          break
        case 'disable':
          this.httpBatchDisable(this.dataSelectList)
          break
        case 'checkPass':
          this.httpBatchCheckPass(this.dataSelectList)
          break
        case 'checkRefuse':
          this.httpCheckRefuse(this.dataSelectList)
          break
        default:
          // console.log('error onBatchAble')
          break
      }
    })
  },
  onSwitch (index, row) { // 状态改变
    let dataItem = this.dataList[index]
    dataItem.switch = !dataItem.switch
    this.$confirm('确认更改？').then(_ => {
      if (row.switch == '0') {
        this.httpEnable(row)
      } else {
        this.httpDisable(row)
      }
    }).catch(_ => {})
  },
  onExport (fileType) { // 导出
    this.httpExport(fileType)
  },
  // 导入
  onImportTemplate () { // 下载导入模板
    getImportTemplate.call(this).then(res => {
      if (!res.headers['content-disposition']) {
        this.$message.warning('导出失败')
        return
      }
      const blob = new Blob([res.data])
      const fileName = res.headers['content-disposition']
        .split(';')[1]
        .toString()
        .replace(/filename=/, '')
      const elink = document.createElement('a')
      elink.download = decodeURI(fileName)
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    }).catch(err => {
      console.log(err, 'onImportTemplate')
    })
  },
  onUploadSuccess (res, file, fileList, formObj) {
    let msg = this.uploadField === 'import' ? '导入' : '上传'
    if (!res.success) {
      console.error(msg + `异常[${res.code}]:${res.message}`)
      this.$message.error(res.message)
    } else {
      formObj[this.uploadField] = res.data
      this.$message.success(msg + '成功')
    }
    let refs = this.$refs[this.uploadField]
    if (Array.isArray(refs)) {
      refs[0].$refs[this.uploadField].clearFiles()
    } else {
      refs.$refs[this.uploadField].clearFiles()
    }
    if (this.uploadField === 'import' && res.success) {
      this.importShow = false
      this.httpQuery()
    }
  },
  onCheckPass () {
    this.$confirm('确认通过审核' + this.dataDetail[this.idName])
      .then(() => {
        this.httpCheckPass(this.dataDetail)
      })
  },
  onCheckRefuse () {
    this.$confirm('确认拒绝审核' + this.dataDetail[this.idName])
      .then(() => {
        this.httpCheckRefuse([this.dataDetail[this.idName]])
      })
  },
  onSelectClear (cacheName) { // 关联下拉列表清除
    this[cacheName] = this[cacheName + 'Copy']
  },
  onSelectFilter (val, form, field, cacheName) { // 下拉列表过滤
    form[field] = val
    if (val) {
      this[cacheName] = this[cacheName + 'Copy'].filter((item, index) => {
        if (String(item.codeId).indexOf(val) > -1 || item.codeName.indexOf(val) > -1) {
          return true
        }
      })
    } else {
      this[cacheName] = this[cacheName + 'Copy']
    }
  },
  onSelectChange (val, cacheName, cascadeCacheName, cascadeUri, form, cascadeField, flag, data) {
    if (String(val)) {
      if (this[cacheName + 'Copy'].some(item => item.codeName === val || String(item.codeId) === String(val))) {
        flag ? form[cascadeField] = '' : ''
        this.httpSelectList(cascadeCacheName, cascadeUri, data)
      }
    } else {
      flag ? form[cascadeField] = '' : ''
      this[cascadeCacheName] = JSON.parse(JSON.stringify(this[cascadeCacheName + 'Copy']))
      // this.httpSelectList(cascadeCacheName, cascadeUri)
    }
  },
  onHeaderClass ({ column }) {
    column.order = column.multiOrder
  },
  onSortChange ({ column, prop }) {
    // if (order == null) { //单列排序
    //   this.pageParam.orderBy = ''
    // } else if (order == 'descending') {
    //   this.pageParam.orderBy = prop + ' desc'
    // } else if (order == 'ascending') {
    //   this.pageParam.orderBy = prop + ' asc'
    // }
    // this.httpQuery()
    if (column.sortable !== 'custom') { // 多列
      return
    }
    if (!column.multiOrder) {
      column.multiOrder = 'ascending'
    } else if (column.multiOrder === 'ascending') {
      column.multiOrder = 'descending'
    } else {
      column.multiOrder = ''
    }
    let order = this.orderList.find(e => e.orderColumn === prop)
    if (order) {
      if (!column.multiOrder) {
        let index = this.orderList.indexOf(order)
        this.orderList.splice(index, 1)
      } else {
        order.orderState = column.multiOrder
      }
    } else {
      if (column.multiOrder) {
        this.orderList.push({
          orderColumn: prop,
          orderState: column.multiOrder
        })
      }
    }
    this.pageParam.orderBy = this.orderList.map(e => e.orderColumn + ' ' + (e.orderState === 'ascending' ? 'asc' : 'desc')).join()
    this.httpQuery()
  },
  isImage (filePath) {
    // 检查文件类型
    let suffix = filePath.substr(filePath.lastIndexOf('.') + 1).toLowerCase()
    return 'jpg,jpeg,png'.indexOf(suffix) > -1
  },
  handlePic (url) {
    this.bigPicUrl = url
    this.dialogPic = true
  },
  // -------------------------------------------------http请求
  httpSelectList (cacheName, url, data) { // 下拉列表查询
    const reqUrl = this.baseUrl + url
    return new Promise((resolve, reject) => {
      axios({
        url: reqUrl,
        method: 'post',
        data: data || {}
      }).then(res => {
        if (res.data.code === '0000') {
          this[cacheName] = res.data.data || []
          // if (!data) {
          this[cacheName + 'Copy'] = this[cacheName]
          // }
        }
        resolve(res)
      }).catch(err => {
        reject(err)
        console.log(err, 'httpSelectList')
      })
    })
  },
  httpQuery () { // 条件查询
    if (this.onQueryInit) {
      this.onQueryInit()
    }
    if (!this.refreshAuto) {
      this.pageLoading = true
    }
    getList.call(this).then(res => {
      if (res.data.code === '0000') {
        this.dataList = res.data.data.data || []
        this.pageTotal = res.data.data.total || 0
        this.dataList.forEach((item, index) => {
          item['switch'] = item.status !== '0'
        })

        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })

        // console.log(this.dataList)
      }
      this.pageLoading = false
    }).catch(err => {
      this.pageLoading = false
      console.log(err, 'httpQuery')
    })
  },
  httpExport (fileType = 'execl') { // 导出
    this.pageLoading = true
    getExport.call(this, fileType).then(res => {
      this.pageLoading = false
      if (!res.headers['content-disposition']) {
        this.$message.warning('导出失败')
        return
      }
      const blob = new Blob([res.data])
      const fileName = res.headers['content-disposition']
        .split(';')[1]
        .toString()
        .replace(/filename=/, '')
      const elink = document.createElement('a')
      elink.download = decodeURI(fileName)
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    }).catch(err => {
      this.pageLoading = false
      console.log(err, 'httpExport')
    })
  },
  httpDetail (data, dialog) { // 提交详情查询请求
    // dialog ? this.pageLoading = true : ''
    this.pageLoading = true
    getDetail.call(this, data).then(res => {
      if (res.data.code === '0000') {
        // this.$message.success(res.data.message)
        this.dataDetail = res.data.data || {}
        this.formEdit = Object.assign({}, this.dataDetail)
        if (this.onEditTreeDefInit) {
          this.onEditTreeDefInit(this.dataDetail)
        }
        dialog ? this[dialog] = true : ''
      }
      this.pageLoading = false
    }).catch(err => {
      this.pageLoading = false
      console.log(err, 'httpDetail')
    })
  },
  httpAdd () { // 提交新增请求
    if (this.onAddInit) {
      this.onAddInit()
    }
    getAdd.call(this).then(res => {
      if (res.data.code === '0000') {
        this.dialogAdd = false
        this.$message.success(res.data.message)
        this.httpQuery()
      }
    }).catch(err => {
      console.log(err, 'httpAdd')
    })
  },
  httpEdit () { // 提交更新请求
    getEdit.call(this).then(res => {
      if (res.data.code === '0000') {
        this.dialogModify = false
        this.$message.success(res.data.message)
        this.httpQuery()
      }
    }).catch(err => {
      console.log(err, 'httpEdit')
    })
  },
  httpDelete (data) { // 提交删除请求
    this.pageLoading = true
    getDelete.call(this, data).then(res => {
      if (res.data.code === '0000') {
        this.$message.success(res.data.message)
        this.httpQuery()
      }
      this.pageLoading = false
    }).catch(err => {
      this.pageLoading = false
      console.log(err, 'httpDelete')
    })
  },
  httpBatchDelete () { // 提交删除请求
    this.pageLoading = true
    getBatchDelete.call(this).then(res => {
      if (res.data.code === '0000') {
        this.$message.success(res.data.message)
        this.httpQuery()
      }
      this.pageLoading = false
    }).catch(err => {
      this.pageLoading = false
      console.log(err, 'httpBatchDelete')
    })
  },
  httpEnable (data) { // 启用
    this.pageLoading = true
    getEnable.call(this, data).then(res => {
      if (res.data.code === '0000') {
        this.$message.success(res.data.message)
        this.httpQuery()
      }
    }).catch(err => {
      this.pageLoading = false
      console.log(err, 'httpEnable')
    })
  },
  httpDisable (data) { // 禁用
    this.pageLoading = true
    getDisable.call(this, data).then(res => {
      if (res.data.code === '0000') {
        this.$message.success(res.data.message)
        this.httpQuery()
      }
    }).catch(err => {
      this.pageLoading = false
      console.log(err, 'httpDisable')
    })
  },
  httpBatchEnable (ids) { // http批量启用
    this.pageLoading = true
    getBatchEnable.call(this, ids).then(res => {
      if (res.data.code === '0000') {
        this.$message.success(res.data.message)
        this.httpQuery()
      }
    }).catch(err => {
      this.pageLoading = false
      console.log(err, 'httpDisable')
    })
  },
  httpBatchDisable (ids) {
    this.pageLoading = true
    getBatchDisable.call(this, ids).then(res => {
      if (res.data.code === '0000') {
        this.$message.success(res.data.message)
        this.httpQuery()
      }
    }).catch(err => {
      this.pageLoading = false
      console.log(err, 'httpDisable')
    })
  },
  httpCheckPass (data) {
    this.pageLoading = true
    getCheckPass.call(this, data).then(res => {
      if (res.data.code === '0000') {
        this.$message.success('已通过审核')
        this.dialogDetail = false
        this.httpQuery()
      }
    }).catch(err => {
      this.pageLoading = false
      console.log(err, 'httpCheckPass')
    })
  },
  httpCheckRefuse (ids) {
    this.$prompt('请输入拒绝的原因', '审核拒绝', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPattern: /\S/,
      inputErrorMessage: '拒绝原因不能为空'
    }).then(({ value }) => {
      const data = { remark: value, ids }
      getCheckRefuse.call(this, data).then(res => {
        if (res.data.code === '0000') {
          this.$message.success(res.data.message)
          this.dialogDetail = false
          this.httpQuery()
        }
      }).catch(err => {
        this.pageLoading = false
        console.log(err, 'httpCheckRefuse')
      })
    })
  },
  httpBatchCheckPass (ids) {
    getBatchCheckPass.call(this, ids).then(res => {
      if (res.data.code === '0000') {
        this.$message.success(res.data.message)
        this.httpQuery()
      }
    }).catch(err => {
      this.pageLoading = false
      console.log(err, 'httpBatchCheckPass')
    })
  }
}
